export const keys = {
  name: 'Full Name',
  firstName: 'First Name',
  lastName: 'Last Name',
  streetNo: 'Street and House-No.',
  country: 'Country of Residence',
  email1: 'E-Mail_01',
  email2: 'E-Mail_02',
  phone1: 'Phone_01',
  phone2: 'Phone_02',
  zipCity: 'ZIP-Code and City',
  language: 'Language',
  gender: 'Gender',
  level: 'Level',
  rate: 'Rate',
  tasks: 'Tasks',
  software: 'Package',
  projects: 'Last Projects',
  link1: 'Link_01',
  link2: 'Link_02',
  link3: 'Link_03',
  vatId: 'VAT-Id'
}


export function stripSpaces(input) {
  while (input.indexOf('  ') > -1) {
    input = input.replaceAll('  ', ' ')
  }
  while (input.charAt(0) === ' ') {
    input = input.substring(1)
  }
  while (input.charAt(input.length - 1) == ' ') {
    input = input.substring(0, input.length - 1)
  }
  return input
}


export function stringToArray(inputString) {
  if (!inputString) {
    return []
  }
  const items = inputString.toString().replaceAll('•', ',').replaceAll(', ', ',').split(',')
  return Array.from(new Set(removeEmptyItems(items.map(stripSpaces))))
}


export function removeEmptyItems(inputArray) {
  return inputArray.filter((item) => (item ? item : undefined)).map(stripSpaces)
}


export function splitStreetNo(streetNoString) {
  const parts = streetNoString.split(' ')

  const streets = parts.filter(
    part => {
      return !part.match(/\d/gm)
    }
  )

  const numbers = parts.filter(
    part => {
      return part.match(/\d/gm)
    }
  )

  return [
    streets.join(' '),
    numbers.join(' ')
  ]
}


export function splitZipCity(zipCityString) {
  const parts = zipCityString.split(' ')

  const zips = parts.filter(
    part => {
      return part.match(/\d/gm)
    }
  )

  const city = parts.filter(
    part => {
      return !part.match(/\d/gm)
    }
  )

  return [
    zips.join(' '),
    city.join(' ')
  ]
}


export function niceRate(rate) {
  return rate.replace(',00', '').replace('EUR', '€').replace('USD', '$').replace('GBP', '£')
}


/**
 * @param {*} a The base object
 * @param {*} b An updated object
 * @returns A new object with just the key/value pairs of B that were different from A.
 */
export function diffFrom(a, b) {
  let result = {}
  for (const key in a) {
    if (b[key] === undefined) {
      continue
    }
    if (b[key] !== a[key]) {
      result[key] = b[key]
    }
  }
  return result
}
